import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputVoucherComponent } from './input-voucher.component';
import { ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from '../../directives/directives.module';
import { FormUtilitiesModule } from '../../ds24-ui/form-utilities';
import { createCustomElement } from '@angular/elements';

@NgModule({
  declarations: [InputVoucherComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DirectivesModule,
    FormUtilitiesModule,
  ],
})
export class InputVoucherModule {
  static initialize(injector: Injector) {
    const customComponent = createCustomElement(InputVoucherComponent, {
      injector: injector,
    });
    customElements.define('ds-orderform-input-voucher', customComponent);
  }
}
